import { Component, createRef, type ErrorInfo, type ReactNode } from 'react';
import { BookOpen } from 'lucide-react';

interface Props { children: ReactNode }
interface State { error: Error | null }

/** Keeps a Writing Room failure from taking down the surrounding chat shell. */
export class WritingRoomErrorBoundary extends Component<Props, State> {
  state: State = { error: null };
  private readonly fallbackRef = createRef<HTMLDivElement>();

  static getDerivedStateFromError(error: Error): State { return { error }; }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[writing-room] layer crash:', error);
    console.error('component stack:', info.componentStack);
  }

  componentDidUpdate(_: Props, previous: State): void {
    if (!previous.error && this.state.error) this.fallbackRef.current?.focus();
  }

  render() {
    if (this.state.error) {
      return (
        <div className="writing-room-error" ref={this.fallbackRef} role="alert" tabIndex={-1}>
          <BookOpen size={32} aria-hidden="true" />
          <div className="writing-room-error__title">Writer&apos;s Room — Layer Error</div>
          <div className="writing-room-error__message">The room could not open safely.</div>
          <button className="btn btn-ghost" onClick={() => this.setState({ error: null })}>Retry</button>
        </div>
      );
    }
    return this.props.children;
  }
}
